import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CadastroAgendamentoComponent } from './pages/agendamento/cadastro-agendamento/cadastro-agendamento.component';
import { ListagemAgendamentoComponent } from './pages/agendamento/listagem-agendamento/listagem-agendamento.component';
import { CadastroPagamentoAgendamentoComponent } from './pages/agendamento/cadastro-pagamento-agendamento/cadastro-pagamento-agendamento.component';
import { CadastroCavaloComponent } from './pages/cadastro-frota/cavalo/cadastro-cavalo/cadastro-cavalo.component';
import { ListagemCavaloComponent } from './pages/cadastro-frota/cavalo/listagem-cavalo/listagem-cavalo.component';
import { CadastroCarretaComponent } from './pages/cadastro-frota/carreta/cadastro-carreta/cadastro-carreta.component';
import { ListagemCarretaComponent } from './pages/cadastro-frota/carreta/listagem-carreta/listagem-carreta.component';
import { HomeComponent } from './pages/home/home.component';
import { LoginUsuarioComponent } from './pages/login-usuario/login-usuario.component';
import { EmailSenhaComponent } from './pages/recuperar-senha/email-senha/email-senha.component';
import { EsqueciSenhaComponent } from './pages/recuperar-senha/esqueci-senha/esqueci-senha.component';
import { AppGuard } from './services/auth.guard';
import { TicketAgendamentoComponent } from './pages/agendamento/ticket-agendamento/ticket-agendamento.component';
import { ListagemServicosComponent } from './pages/servicos/listagem-servicos/listagem-servicos.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { ListagemLaudosHigienizacaoComponent } from './pages/laudo-higienizacao/listagem-laudos-higienizacao/listagem-laudos-higienizacao.component';
import { CadastroLaudoHigienizacaoComponent } from './pages/laudo-higienizacao/cadastro-laudo-higienizacao/cadastro-laudo-higienizacao.component';
import { CadastroEntradaServicosComponent } from './pages/servicos/cadastro-entrada-servicos/cadastro-entrada-servicos.component';
import { CadastroUsuarioComponent } from './pages/usuario/cadastro-usuario/cadastro-usuario.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginUsuarioComponent },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [() => inject(AppGuard).canActivate()]
  },
  { path: 'recuperar-senha', component: EmailSenhaComponent },
  { path: 'esqueci-senha', component: EsqueciSenhaComponent },
  { path: 'esqueci-senha-interno', component: EsqueciSenhaComponent },
  { path: 'cadastro-usuario', component: CadastroUsuarioComponent },
  { path: 'pagamento', component: CadastroPagamentoAgendamentoComponent },
  { path: 'ticket-agendamento', component: TicketAgendamentoComponent },
  {
    path: 'listagem',
    children: [
      {
        path: 'carreta',
        component: ListagemCarretaComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'cavalo',
        component: ListagemCavaloComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'agendamento',
        component: ListagemAgendamentoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },

      {
        path: 'servicos',
        component: ListagemServicosComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'laudos-higienizacao',
        component: ListagemLaudosHigienizacaoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      }
    ]
  },
  {
    path: 'cadastro',
    children: [
      {
        path: 'cavalo',
        component: CadastroCavaloComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'carreta',
        component: CadastroCarretaComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'agendamento',
        component: CadastroAgendamentoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'laudo-higienizacao',
        component: CadastroLaudoHigienizacaoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'servicos',
        component: CadastroEntradaServicosComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      }
    ]
  },
  {
    path: 'edicao',
    children: [
      {
        path: 'usuario',
        component: CadastroUsuarioComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      }
    ]
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
